import { PlanIdTypeSafe, PlanType } from "@/types/PlanTypes";
import useSWR from "@/hooks/useSWR";
import { getToken } from "@/security/authentication";
import { toPlanId } from "@/utils/toPlanId";
import { useSession } from "@/security/RouteGuards";

export default function usePlan(
  planId: PlanIdTypeSafe,
  enabled: boolean = true
) {
  const token = getToken();
  const { subscription } = useSession();

  const planIdToUse = planId && toPlanId(planId) ? planId : subscription?.plan;

  return useSWR<PlanType>({
    enabled: !!token && enabled && !!planIdToUse,
    url: `/subscription/plan/${planIdToUse}/`,
  });
}
